import React from 'react';
import { PropTypes } from 'prop-types';
import EmailInfo from './EmailInfo';
import EmptyEmail from './EmptyEmail';

// Turn this into a stateful component that either renders EmptyEmail or EmailInfo, depending on whether there is a defined customer email.

class EmailForm extends React.Component {
  // Construct with the actual user's email ...
  constructor(props) {
    super(props);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.state = { email: props.email };
  }

  /**
   * Handle clicks to the 'edit' button within EmailInfo.  This changes the EmailForm to show <EmptyEmail> ...
   */
  handleEditClick() {
    // Set an empty email.  This will trigger a re-render, and at the end of the render they should end up with EmptyEmail...
    this.setState({
      email: this.props.email,
      edit: true,
    });
  }

  render() {
    let emailForm;

    // Use either an EmailInfo or an EmptyEmail, depending on whether or not customer email is populated or not...
    // 'Edit' is false, empty form should be presented to user.
    if (this.state.email.length > 0 && !this.state.edit) {
      emailForm = (
        <EmailInfo email={this.state.email} onEdit={this.handleEditClick} />
      );
      // 'Edit' is true, email should be shown to user.
    } else if (this.state.email.length > 0 && this.state.edit) {
      emailForm = (
        <EmptyEmail onChanged={this.props.onChanged} email={this.state.email} />
      );
    } else {
      // Otherwise, user should get the blank component with the input and save button ...
      emailForm = <EmptyEmail onChanged={this.props.onChanged} />;
    }

    return <div className="email-form">{emailForm}</div>;
  }
}

EmailForm.propTypes = {
  email: PropTypes.string.isRequired,
  onChanged: PropTypes.func,
};

export default EmailForm;



// WEBPACK FOOTER //
// ./src/containers/CartPage/EmailForm.jsx